module.exports = __webpack_public_path__ + "img/5.3a15956c.jpg";